import { useQuery } from 'react-query';

import { useAuth } from '@/lib/hooks/useAuth';
import { apiGetVault } from '@/services/user.api';
import { useSettingsStore } from '@/store';

export function useTwinVault() {
  const { isAuthenticated } = useAuth();
  const { settings } = useSettingsStore();
  const userPays = settings?.suVariables?.userPays;

  const isUsingExternalCurrency =
    settings?.app?.externalCurrency?.enable ?? false;

  const { data: vaultResponse, ...vaultQuery } = useQuery({
    queryKey: ['vault-details'],
    queryFn: apiGetVault,
    enabled: isAuthenticated && (userPays || isUsingExternalCurrency),
    // staleTime: 60_000, // Cache for 1 minute
  });

  const vaultData = vaultResponse?.data?.data ?? {};

  return {
    vaultData,
    vaultEnabled: isAuthenticated && userPays,
    ...vaultQuery,
  };
}
